module.exports = __webpack_public_path__ + "static/img/pc2.8e87223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc2.png
// module id = jfXB
// module chunks = 1